const breakpoints = {
  mobile: 375,
  tablet: 768,
  desktop: 1158
}

export default breakpoints 